/* eslint react/prop-types: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

const RouteAuthenticated = ({ component: C, props: cProps, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      cProps.userToken !== null
        ? <C {...props} {...cProps} />
        : <Redirect
          to={
            cProps.fromFrame ?
              '/welcome' :
              `/agreements?redirect=${props.location.pathname}${props.location.search}`
          }
        />
    )}
  />
);

RouteAuthenticated.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.node,
  ]).isRequired,
  userToken: PropTypes.string,
};

RouteAuthenticated.defaultProps = {
  userToken: null,
};

export default RouteAuthenticated;



// WEBPACK FOOTER //
// ./src/components/RouteAuthenticated.jsx